/**
 * Parameters of the verification polling, shared by the phone and the email waits: same values, same
 * machine. They are pending a cost review with the backend team, so they live in one place.
 */

/** How often the polling asks for the account status. */
export const VERIFICATION_POLL_INTERVAL_MS = 30_000;

/**
 * No delay before the first query, so the user who opens the link in two seconds is not left
 * watching a spinner until the first tick.
 */
export const VERIFICATION_FIRST_POLL_DELAY_MS = 0;

/**
 * When the polling stops. A forgotten tab must not poll forever, and stopping costs nothing: the
 * link stays valid for a week.
 */
export const VERIFICATION_TIMEOUT_MS = 15 * 60_000;

/** Failures in a row before the inline notice appears. The polling continues either way. */
export const VERIFICATION_NETWORK_NOTICE_THRESHOLD = 3;
